import { Component, Emit, Prop, Vue ,Watch} from 'vue-property-decorator';
import { ShippingRecordItem, 
    ShippingRecordDestination, 
    ShippingDestinationDetailItem,
    ShippingRecordHarvestRecord, 
    SelectAgriFieldAndPlanting, 
    ShippingDestination,
    QualityStandard, 
    WeightUnit,
    RecordInfoModel ,
    File,
    HarvestRecordData, 
    HarvestShippingItem, 
    HarvestShipping,  
    HarvestRecordItem ,
    Machine,
    Worker,
    WorkTimeState,
    Item,
    ShippingDestinationsHarvestRecordData,
    ShippingRecordHarvestRecords
} from "@/types/Component";
import { ShippingRecordResponse, QualityStandardResponse, WeightUnitResponse } from "@/types/APIResponse"
import Thumbnail from '@/components/Thumbnail/Thumbnail.vue';
import moment from 'moment';
import SelectFromHarvestRecord from '@/components/Record/SelectFromHarvestRecord/SelectFromHarvestRecord.vue';
import SelectFromPlantings from '@/components/Record/SelectFromPlantings/SelectFromPlantings.vue'
import RecordInfo from '@/components/Record/RecordInfo/RecordInfo.vue'
import SelectFromWorkRecords from '@/components/Record/SelectFromWorkRecords/SelectFromWorkRecords.vue'
import ShippingDestinationSelectModal from "@/assets/common/Modal/ItemSelectModal/ShippingDestinationSelectModal/ShippingDestinationSelectModal.vue";
import EditModal from '@/assets/common/Modal/EditModal/EditModal.vue';
import { toCamel } from 'snake-camel';
import store from '@/assets/common/store/store';
import SelectTime from '@/components/Record/WorkRecord/SelectTime/SelectTime.vue'
import SelectInterval from '@/components/Record/WorkRecord/SelectInterval/SelectInterval.vue'
import MachineSelectModal from '@/assets/common/Modal/ItemSelectModal/MachineSelectModal/MachineSelectModal.vue'
import WorkerSelectModal from '@/assets/common/Modal/ItemSelectModal/WorkerSelectModal/WorkerSelectModal.vue'
import Machines from '@/components/Machines/Machines';
import Workers from '@/components/Workers/Workers';
import WorkRecordModal from '@/assets/common/Modal/WorkRecordModal/WorkRecordModal.vue';
import axios, { AxiosRequestConfig } from 'axios';

type ShippingRecordPostModel = {
  shipping_date: string;
  shipping_type: string;
  isChecked :boolean;
  isValidationNeeded :boolean;
  measurement_timing_id :string | null;
  harvest_record_id: string[] | null;
  planting_id: string | null;
  agri_field_id: string | null;
  work_record_id :string | null
  deletedShippingDetailIds : string []
  workers:WorkerPost []
  deletedWorkers : string []
  deletedWorker: {
    worker_id : string , 
    worker_updated_time : string
    }[],
  machines : MachinePost[]
  deletedMachines: string[],
  deletedMachine: {
    machine_id : string , 
    machine_updated_time : string
    }[],
  shipping_destinations: {
    shipping_destination_id: string;
    shipping_destination_details: {
      quality_standard_id: string | null;
      quantity: number | null;
      weight_unit_id: string | null;
      amount: number | null;
      unit_price: number | null;
      memo: string;
      shipping_split_id :string | null;
      shipping_collective_id :string | null;
      processType : string | null;
      updated : string | null;
    }[];
  }[];
  lot_number: string;
  memo: string;
  workRecordOption: string;
  isHarvestChanged: boolean;
  updated_shipping_time: string | null;
  work_record_updated : string | null;
  shipping_record_work_records_updated : string | null
  shipping_record_harvest_records: ShippingRecordHarvestRecords []
  shipping_destination_harvest_record_data: ShippingDestinationsHarvestRecordData[]
  deleted_shipping_details: {
  shipping_record_data_id: string;
  updated: string;
  }[]
}

type QualityStandards = {
  qualityStandards: QualityStandard[];
}

type WeightUnits = {
  weightUnits: WeightUnit[];
}

type WorkerPost = {
  processType: string;
    worker_id: string,
    start_worktime: string | null, // 開始時間（時間で入力の場合null）
    plan_start_worktime: string | null, // 開始時間（時間で入力の場合null）
    actual_start_worktime: string | null, // 開始時間（時間で入力の場合null）
    end_worktime: string | null, // 終了時間（時間で入力の場合null）
    plan_end_worktime: string | null, // 終了時間（時間で入力の場合null）
    actual_end_worktime: string | null, // 終了時間（時間で入力の場合null）
    rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    plan_rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    actual_rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    work_time: number, // 作業時間
    plan_work_time: number, // 作業時間
    actual_work_time: number, // 作業時間
    memo: string, // メモ
    kind: "SCHEDULE" | "ACTUAL";
    worker_updated_time: string
}

type MachinePost = {
    processType: string;
    machine_id: string,
    start_worktime: string | null, // 開始時間（時間で入力の場合null）
    end_worktime: string | null, // 終了時間（時間で入力の場合null）
    rest_time: number | null, // 休憩時間（時間で入力の場合null）（分で入力）
    work_time: number, // 作業時間
    memo: string, // メモ
    machine_updated_time: string
}

@Component({
  components: {
    SelectFromHarvestRecord,
    SelectFromPlantings,
    SelectFromWorkRecords,
    ShippingDestinationSelectModal,
    EditModal,
    RecordInfo,
    Thumbnail,
    SelectTime,
    SelectInterval,
    MachineSelectModal,
    WorkerSelectModal,
    WorkRecordModal
    }
})

export default class ShippingRecord extends Vue {
  private apiServerBaseUrl = process.env.VUE_APP_API_URL_BASE
  @Prop()
  private id?: string

  @Prop({ default: ''})
  private recordDate!: string

  @Prop({ default: false})
  private isAdmin!: boolean

  @Prop({ default: false })
  private readonly isShow!: boolean;

  @Prop()
  private shippingRecordDate!: string

  @Prop({ default: false })
  private readonly isRefresh!: boolean;
 
  @Prop({ default: false })
  private readonly isCollectiveListRefresh!: boolean;

  @Prop({})
  private shippingCollectiveIds! : string

  @Prop({})
  private shippingSplitIds! : string
  

  closeModal() {
    if (this.refresh) {
      this.$emit('update:isRefresh', true);
      this.refresh = false;
    }
    this.plantingBasicUnitId =null
    if(this.isShippingOpen === 'true' && this.id == null || this.isShippingOpen === 'true' && this.id != null ){
          this.$root.$emit('header-inert', false);
          this.$router.push(`/${this.$route.query.return_to}?date=${this.shippingRecordDate}`).then(() => {return})
      }
      else{
        if (store.getters.isInputChanged) {
          const confirm = window.confirm("変更内容を破棄します。よろしいですか？");
          if (confirm) {
          store.dispatch("doUpdateIsInputChanged", false);
          this.shippingCollectiveIds= ''
          this.editTargetId=''
          this.shippingId =''
          this.modeType =''
          this.shippingRecordId=""
          this.$emit('update:isShow', false);
         }
      }else{
          this.shippingCollectiveIds= ''
          this.editTargetId=''
          this.modeType =''
          this.shippingId =''
          this.shippingRecordId=""
          this.$emit('update:isShow', false);
      }
    }
  }

  @Prop()
  private shippingId?: string

  @Prop()
  private harvestRecordToShippingModel:  ShippingRecordHarvestRecord[] = []

  @Prop()
  private mode?: string

  @Prop()
  private isShippingOpen!: string


  @Watch("isShow")
  handleShippingRecordModal() {
          if(this.shippingId) {
              this.editTargetId = this.shippingId
              this.shippingRecordId = this.shippingId
          } else {
              this.editTargetId = ''
          }
          if(this.mode) {
              this.modeType = this.mode
          }
          this.init()
  }


  private modeType = ''
  private apiBaseUrl = '/admin/shipping_records'
  private today = moment(new Date()).format('YYYY-MM-DD')
  private defaultShippingRecord: ShippingRecordItem = {
    id: "",
    shippingDate: this.shippingRecordDate? this.shippingRecordDate : this.today,
    classification :"SHIPPING",
    measurementTimingId :"",
    shippingType: "",
    harvestRecords: null,
    planting: null,
    agriField: null,
    workers: [],
    machines: [],
    workRecordId : '',
    harvestRecordData :[],
    shippingDestinations: [],
    lotNumber: "",
    memo: "",
    workRecordOption: "WITHWORK",
    createdUser: {
      id: "",
      name: "",
      imageId: ""
    },
    created: this.today,
    updatedUser: {
      id: "",
      name: "",
      imageId: ""
    },
    updated: this.today,
    updatedShippingTime:'',
    workRecordUpdated:"",
    shippingRecordWorkRecordsUpdated:"",
    shippingDestinationsHarvestRecordData :[],
    shippingRecordHarvestRecords : []
  }
  workRecordOptionDef = '';
  private plantingBasicUnitId: string | null = null
  private shippingRecord: ShippingRecordItem = this.defaultShippingRecord
  private qualityStandards: QualityStandard[] = []
  private harvestQualityStandards: QualityStandard[] = []
  private weightUnits: WeightUnit[] = []
  private harvestRemainings = []
  private formattedHarvestRemainings = '';
  private harvestHoldings: { [id: string]: string }[] = [];
  private measurementTimings: HarvestShippingItem[] = []
  private defaultWeightUnit: WeightUnit = {
    id: null,
    name: 'kg',
    weightPerUnit: 1,
    isHidden: false
  }
  private updatedShippingTime : string | null = null;
  private workRecordUpdated : string | null = null;
  private alertMessage = 'リクエストに失敗しました。\n'
  private shippingRecordWorkRecordsUpdated : string | null = null;
  private shippingDestinationsHarvestRecordData : ShippingDestinationsHarvestRecordData [] =[]
  private shippingRecordHarvestRecords : ShippingRecordHarvestRecords [] =[]
  private isLoading = false;

  private defaultDestinationDetail: ShippingDestinationDetailItem = {
    shippingRecordDestinationId:null,
    qualityStandardId: null,
    qualityStandardName: '',
    harvestQualityStandardId: null,
    quantity: null,
    weightUnitId: null,
    weightUnitName: this.defaultWeightUnit.name,
    amount: null,
    unitPrice: null,
    memo: '',
    selectedWeightUnit: this.defaultWeightUnit,
    shippingSplitId:'' ,
    shippingCollectiveId:'',
    processType: '',
    updated : '' 
  }
  private isAutoCalc = true
  private machines :Machine[] =[]
  private workers :Worker[] =[]
  // 出荷対象の選択状態管理
  private selectedShippingTarget: {
    harvestRecordId: string[];
    agriFieldId: string | null;
    plantingId: string | null;
  } = {
    harvestRecordId: [],
    agriFieldId: null,
    plantingId: null
  }

  // 収穫記録から選択モーダル
  private showSelectFromHarvestRecord = false
  private selectedHarvestRecords: ShippingRecordHarvestRecord[] = []

  // 作付から選択モーダル
  private showSelectFromPlantings = false
  // private selectMeasurementTiming = false

  // 出荷先選択モーダル
  private showDestinationModal = false
  private selectedDestinations: ShippingDestination[] = []

  // 編集モーダル
  private showEditModal = false
  private editModalBaseUrl = ''

  // 作成者/更新者
  private recordInfo: RecordInfoModel | null = null

  private workerInputType: 'TIME_POINT' | 'TIME_INTERVAL' = 'TIME_POINT'
  private machineInputType: 'TIME_POINT' | 'TIME_INTERVAL' = 'TIME_POINT'
  private targetSelectTime: WorkTimeState | null = null
  private showSelectTime = false;
  private showSelectInterval = false
  private selectTimeIndex: number | 'all' | undefined;
  private workerOrMachine: 'WORKER' | 'MACHINE' = 'WORKER'
  private showMachineSelect = false
  private showWorkerSelect = false
  private editTargetId =''
  private shippingRecordId =''
  private measurementTimingId = ''
  private headerTitle = ''
  private subTitle = ''
  private workRecordId = ''
  private existingWorkRecordId = '';
  private harvestRecord: HarvestRecordItem | null = null
  private harvestRecordData: HarvestRecordData | null = null
  private isChecked = false
  private isValidationNeeded = true
  private isCheckDisable = false
  private showWork = false
  private workMode: string | null = null;
  private refresh = false;
  private showSelectFromWorkRecords = false
  deletedShippingDetailIds: string[] = []
  private isHarvestChanged = false
  private originalWorkers = [] as Worker[];
  private originalMachines = [] as Machine[];
  private originalShippingDetails = [] as ShippingRecordDestination[];

   get isAnyShippingModalOpen(): boolean {
    return (
    this.showSelectFromPlantings ||
    this.showSelectTime ||
    this.showSelectInterval ||
    this.showMachineSelect ||
    this.showWorkerSelect ||
    this.showSelectFromWorkRecords || 
    this.showSelectFromPlantings || 
    this.showWork ||
    this.showSelectFromHarvestRecord ||
    this.showDestinationModal ||
    this.showEditModal
    )
    }

  created() {
    this.handleShippingRecordModal();
    this.init()
   }

  init() {
     this.isChecked = false;
     this.isCheckDisable = false;
     this.getQualityStandards()
     this.getWeightUnits()
     this.getMeasurementTiming()
     this.deletedShippingDetailIds = [];
     this.originalMachines = [];
     this.originalWorkers =  [];
     this.originalShippingDetails = [];
     this.isHarvestChanged = false;
    if(this.modeType == 'edit' && this.shippingRecordId){
      this.headerTitle = '出荷記録編集'
      this.getShippingRecord(this.editTargetId);
     }
    else {
         this.headerTitle = '出荷記録新規作成'
         this.subTitle = this.modeType === 'copy' ? '（複製）': '';
         this.formattedHarvestRemainings = '';
         this.measurementTimingId = '';
      if (this.editTargetId) {
         this.getShippingRecord(this.editTargetId)
     }else{
         this.shippingRecord = Object.assign({}, this.defaultShippingRecord)
         this.getPreferredWorkOption()
      if (this.harvestRecordToShippingModel?.length > 0) {
         this.commitHarvestRecords(this.harvestRecordToShippingModel);
         this.measurementTimingId = '';
      }
    }
    if(this.mode ==='new' && this.shippingCollectiveIds != "" && this.shippingCollectiveIds != undefined){
      this.modeType = this.mode;
        const idString: string = this.shippingCollectiveIds.split('::').join(',');
        this.$apiClient.doRequest('get', `/admin/shipping_record_register_collective/shipping_records_create/${idString}`)
          .then((res) => {
          const  filteredSplitData = res.shippingRecordSplitData.filter((splitdatas:any) => this.shippingSplitIds.includes(splitdatas.shippingSplitId))
            const processedData = res.shippingRecordCollectiveDetailsItem?.map((detail: any) => {
              const splitData = filteredSplitData?.find(
                (split: any) => split.shippingCollectiveDataId === detail.shipping_record_collective_id
              );
              return {
                shipping_date: detail.shipping_date,
                planting_id: splitData ? splitData.plantingId : detail.planting_id,
                planting_name: splitData ? splitData.plantingName || detail.planting_name : detail.planting_name,
                agrifield_id: splitData ? splitData.agriFieldId : null,
                agrifield_name: splitData ? splitData.agriFieldName || null : null,
                shippingDestinations: {
                 shipping_destination_id :detail.shipping_destination_id,
                 shipping_destination_name :detail.shipping_destination_name,
                 shippingDestinationDetails :[{
                    quality_standard_id: detail.quality_standard_id,
                    quantity: splitData ? splitData.quantity : detail.quantity,
                    weight_unit_id: detail.weight_unit_id,
                    amount: detail.unit_price ?  Math.round(detail.unit_price * splitData.quantity ):null,
                    unit_price: detail.unit_price,
                    memo: detail.memo,
                    shippingSplitId:splitData.shippingSplitId,
                    colletciveShippingId:splitData.shippingCollectiveDataId
                  }],
                },
                workers: detail.workers || [],  
                machines: detail.machines || [],  
                harvestRecordData: detail.harvestRecordData || [],  
              };
            }) || [];
            const mergedShippingDestinations: ShippingRecordDestination[] = [];
            processedData.forEach((destination: any) => {
            const destinationId = destination.shippingDestinations.shipping_destination_id;
            const destinationName = destination.shippingDestinations.shipping_destination_name;
            const existingDestination = mergedShippingDestinations.find(
            (dest) => dest.id === destinationId
            );
            const details = destination.shippingDestinations.shippingDestinationDetails?.map((detail: any) => ({
            qualityStandardId: detail.quality_standard_id,
            harvestQualityStandardId: null,
            quantity: detail.quantity,
            weightUnitId: detail.weight_unit_id,
            selectedWeightUnit: detail.weight_unit_id
            ? this.getWeightUnit(detail.weight_unit_id)
            : this.defaultWeightUnit,
            amount: detail.amount,
            unitPrice: detail.unit_price,
            memo: detail.memo,
            shippingSplitId: detail.shippingSplitId,
            shippingCollectiveId: detail.colletciveShippingId,
            }));
            if (existingDestination) {
              existingDestination.id = destinationId;
              existingDestination.name = destinationName;
              existingDestination.shippingDestinationDetails.push(...details);
            } else {
              mergedShippingDestinations.push({
              id: destinationId,
              name: destinationName,
              shippingDestinationDetails: details,
            });
            }
            });
             this.shippingRecord = {
              id: "",
              shippingDate: processedData[0]?.shipping_date? processedData[0]?.shipping_date : this.today,
              classification :"SHIPPING",
              measurementTimingId :"",
              shippingType: "PLANTING",
              harvestRecords: null,
              planting: {
                id: processedData[0].planting_id,  
                name: processedData[0].planting_name,  
              },
              agriField: {
                id: processedData[0].agrifield_id,  
                name: processedData[0].agrifield_name,  
              },
              workers: [],
              machines: [],
              workRecordId : '',
              harvestRecordData :[],
              shippingDestinations: mergedShippingDestinations,
              lotNumber: "",
              memo: "",
              workRecordOption: "WITHWORK",
              createdUser: {
                id: "",
                name: "",
                imageId: ""
              },
              created: this.today,
              updatedUser: {
                id: "",
                name: "",
                imageId: ""
              },
              updated: this.today,
              updatedShippingTime : '',
              workRecordUpdated :"",
              shippingRecordWorkRecordsUpdated:"",
              shippingDestinationsHarvestRecordData:[],
              shippingRecordHarvestRecords:[]
            }
          });    
    }
   }
  }

  private getMeasurementTiming() {
    this.$apiClient.doRequest('get', '/measurement_timings?with_hidden=true').then(ret => {
        const item = toCamel(ret) as HarvestShipping
        this.measurementTimings = item.measurementTimings
    }).catch(() => {
        return
    })
 }

  @Watch('shippingRecord.workRecordOption')
  private async resetWorkData() {
    this.shippingRecord.workers = []
    this.shippingRecord.machines = []
    this.workRecordId = ''
    if (this.mode == "edit" && ((this.workRecordOptionDef === 'WITHWORK' && this.shippingRecord.workRecordOption === 'WITHWORK') || (this.workRecordOptionDef === 'LINKWORK' && this.shippingRecord.workRecordOption === 'LINKWORK'))) {
      this.workRecordId = this.existingWorkRecordId
      if (this.existingWorkRecordId) {
        const res = await this.$apiClient.doRequest('get', '/work_records/' + this.existingWorkRecordId)
        this.commitWorkRecord(res);
      }
    } else if (this.mode == "copy" && this.workRecordOptionDef === 'WITHWORK' && this.shippingRecord.workRecordOption === 'WITHWORK') {
      if (this.existingWorkRecordId) {
          const res = await this.$apiClient.doRequest('get', '/work_records/' + this.existingWorkRecordId)
          this.commitWorkRecord(res);
      }
    }
  }

  private handleWorkRecordPopup() {
    const errmsg: string[] = [];
    if (!this.shippingRecord.shippingDate) errmsg.push('日付を選択してください。');
    if (!this.shippingRecord?.agriField?.id || !this.shippingRecord?.planting?.id) {
      errmsg.push('作付・圃場を選択してください。');
    }
    if (errmsg.length > 0) {
      window.alert(errmsg.join('\n'));
      return false;
    }
    return this.showSelectFromWorkRecords = true;
  }

  private commitWorkRecord(workRecord: any) {
      this.shippingRecord.workers = []
      this.shippingRecord.machines = []
      this.workRecordId = workRecord.id;
      this.workRecordUpdated = workRecord.updated;
      const workerRecord : Worker[] = workRecord.workers.map((item: any) => {
          return {
              worker: {
                  id: item.worker.id, 
                  name: item.worker.name 
              },
              startWorktime: workRecord.kind === "SCHEDULE" ? item.plan_start_worktime : item.actual_start_worktime,
              planStartWorktime: item.plan_start_worktime,
              actualStartWorktime: item.actual_start_worktime,
              endWorktime: workRecord.kind === "SCHEDULE" ? item.plan_end_worktime : item.actual_end_worktime,
              planEndWorktime: item.plan_end_worktime, 
              actualEndWorktime: item.actual_end_worktime,
              restTime: workRecord.kind === "SCHEDULE" ? item.plan_rest_time : item.actual_rest_time,
              planRestTime: item.plan_rest_time, 
              actualRestTime: item.actual_rest_time,
              workTime: workRecord.kind === "SCHEDULE" ? item.plan_work_time : item.actual_work_time,
              planWorkTime: item.plan_work_time, 
              actualWorkTime: item.actual_work_time,
              memo: item.memo,
              kind: "ACTUAL",
              workerUpdatedTime: item.workerUpdatedTime ? item.workerUpdatedTime : item.worker_updated_time
          };
      });
      this.shippingRecord.workers = workerRecord;
      let workerInputTypeIsTimePoint;
      if (this.shippingRecord.workers.length) {
          workerInputTypeIsTimePoint = this.shippingRecord.workers
          .map(w => workRecord.kind === "SCHEDULE" ?  w.planStartWorktime !== null && w.planEndWorktime !== null && w.planRestTime !== null : w.actualStartWorktime !== null && w.actualEndWorktime !== null && w.actualRestTime !== null)
          .reduce((res, b) => res && b)
      }
      this.workerInputType = workerInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'
      const machineRecord : Machine[] = workRecord.machines.map((item: any) => {
          return {
              machine: {
                  id: item.machine.id, 
                  name: item.machine.name 
              },
              startWorktime: item.start_worktime,
              endWorktime: item.end_worktime,
              restTime: item.rest_time,
              workTime: item.work_time,
              memo: item.memo,
              machineUpdatedTime: item.machineUpdatedTime ? item.machineUpdatedTime : item.machine_updated_time
          };
      });
      let machineInputTypeIsTimePoint;
      this.shippingRecord.machines = machineRecord;
      this.originalMachines = this.shippingRecord.machines.map(w => ({...w}))
      this.originalWorkers = this.shippingRecord.workers.map(m => ({...m}))
      if (this.shippingRecord.machines.length) {
          machineInputTypeIsTimePoint = this.shippingRecord.machines
              .map(m => m.startWorktime !== null && m.endWorktime !== null && m.restTime !== null)
              .reduce((res, b) => res && b)
      }
      this.machineInputType = machineInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'
      this.showSelectFromWorkRecords = false
 }

  async getShippingRecord(id: string) {
    this.isHarvestChanged = false;
    this.deletedShippingDetailIds = [];
    this.workRecordOptionDef = ''
    this.isChecked = false;
    this.isCheckDisable = false;
    this.measurementTimingId = "";
    return this.$apiClient.doRequest('get', `${this.apiBaseUrl}/${id}`)
    .then((res: ShippingRecordResponse)=>{
      const camelRes = toCamel(res) as ShippingRecordItem
      this.shippingRecord = camelRes
      this.workRecordId = this.shippingRecord.workRecordId
      this.existingWorkRecordId = this.shippingRecord.workRecordId
      this.workRecordOptionDef = this.shippingRecord.workRecordOption
      if (this.modeType === 'copy') {
        this.workRecordId = '';
      }
      if (this.shippingRecord.shippingType == "PLANTING" && this.shippingRecord.harvestRecords && this.shippingRecord.harvestRecords.length > 0) {
        this.isChecked = true
        this.isCheckDisable = true
        this.measurementTimingId = this.shippingRecord.harvestRecords?.[0]?.measurementTimingId || ""
        if (this.modeType !== 'edit') {
          this.shippingRecord.harvestRecords = null;
        }
      }
      this.shippingRecord.harvestRecords = camelRes.harvestRecords?.sort((a, b) => a.harvestDate.localeCompare(b.harvestDate)).map(record => {
        const aggregatedData: any[] = [];
        let qualityData = ''
        const data = this.shippingRecord.harvestRecordData.filter(i => record.id === i.harvestRecordId);
        if (data.length > 0) {
          data.forEach(dataItem => {
            if (dataItem.quantity != null && dataItem.quantity !== undefined) {
              const wpu = dataItem.weightUnitId != null ? dataItem.weightPerUnit : 1;
              if (wpu != null) {
                const quantityToAdd = dataItem.quantity * wpu;
                const remainingQuantityToAdd = dataItem.remainingQuantity != null ? dataItem.remainingQuantity * wpu : dataItem.quantity * wpu;
                const existingDetailIndex = aggregatedData.findIndex(item => item.quality_standard_id === dataItem.qualityStandardId);
                if (existingDetailIndex !== -1) {
                  aggregatedData[existingDetailIndex].quantity += quantityToAdd;
                  aggregatedData[existingDetailIndex].remainingQuantity += remainingQuantityToAdd;
                } else {
                  aggregatedData.push({
                    quality_standard_id: dataItem.qualityStandardId,
                    quality_standard_name: dataItem.qualityStandardName,
                    quantity: quantityToAdd,
                    remainingQuantity: remainingQuantityToAdd,
                    isWpuAvailable: true,
                  });
                }
              } else {
                const existingDetailIndex = aggregatedData.findIndex(item => item.quality_standard_id === dataItem.qualityStandardId);
                if (existingDetailIndex !== -1) {
                  aggregatedData[existingDetailIndex].isWpuAvailable = false;
                } else {
                  aggregatedData.push({
                    quality_standard_id: dataItem.qualityStandardId,
                    quality_standard_name: dataItem.qualityStandardName,
                    quantity: 0,
                    remainingQuantity: 0,
                    isWpuAvailable: false,
                  });
                }
              }
            }
          });
        }
        aggregatedData.sort((a, b) => a.quality_standard_name.localeCompare(b.quality_standard_name)).forEach((item, index) => {
          const quantityText = item.isWpuAvailable ? `${this.formatDigit(item.quantity)}kg` : `<span style="color: red;" class="tooltip">単位未設定</span>`;
          const remainingQuantityText = item.isWpuAvailable ? `(${this.formatDigit(item.remainingQuantity)}kg)` : `<span style="color: red;" class="tooltip">(単位未設定)</span>`;
          qualityData += `${item.quality_standard_name}: ${quantityText}${remainingQuantityText}`;
          if (index < aggregatedData.length - 1) {
            qualityData += " / ";
          }
        });
        return {
          id: record.id,
          harvestDate: record.harvestDate,
          measurementTimingId: record.measurementTimingId,
          planting: camelRes.planting,
          agriField: camelRes.agriField,
          qualityData: qualityData
        }
      }) as ShippingRecordHarvestRecord[]
      this.formHarvestQualityStandards(this.shippingRecord.harvestRecords);
      const harvestRecordData: HarvestRecordData[] = this.shippingRecord.harvestRecordData?.map((item: any) => {
        return {
            harvestRecordDataId:item.harvestRecordDataId ||null,
            harvestRecordId: item.harvestRecordId,
            qualityStandardId: item.qualityStandardId || null,
            qualityStandardName: item.qualityStandardName,
            quantity: item.quantity,
            remainingQuantity: item.remainingQuantity,
            weightPerUnit: item.weightPerUnit,
            weightUnitId: item.weightUnitId,
            weightUnitName: item.weightUnitName,
            harvestLotNumber:item.harvestLotNumber,
            qualityDisplayFlag:item.qualityDisplayFlag
        };
    });
    this.getPlantingWeightUnitId();
    this.shippingRecord.harvestRecordData = harvestRecordData;
      const workerRecord : Worker[] = this.shippingRecord.workers?.map((item: any) => {
        return {
            worker: {
                id: item.worker.id, 
                name: item.worker.name 
            },
            startWorktime: item.actualStartWorktime ,
            planStartWorktime: item.planStartWorktime,
            actualStartWorktime: item.actualStartWorktime,
            endWorktime: item.actualEndWorktime,
            planEndWorktime: item.planEndWorktime, 
            actualEndWorktime: item.actualEndWorktime,
            restTime:  item.actualRestTime,
            planRestTime: item.planRestTime, 
            actualRestTime: item.actualRestTime,
            workTime:  item.actualWorkTime ,
            planWorkTime: item.planWorkTime, 
            actualWorkTime: item.actualWorkTime,
            quantity:item.quantity,
            memo: item.memo,
            kind: item.kind,
            workerUpdatedTime: item.workerUpdatedTime
        };
    });
    this.shippingRecord.workers = workerRecord
    this.machines = this.shippingRecord?.machines
    this.originalMachines = this.machines.map(w => ({...w}))
    this.originalWorkers = this.shippingRecord.workers.map(m => ({...m}))
    this.originalShippingDetails = JSON.parse(JSON.stringify(this.shippingRecord.shippingDestinations));
    this.updatedShippingTime = this.shippingRecord.updatedShippingTime,
    this.workRecordUpdated = this.shippingRecord.workRecordUpdated,
    this.shippingRecordWorkRecordsUpdated = this.shippingRecord.shippingRecordWorkRecordsUpdated,
    this.shippingDestinationsHarvestRecordData = this.shippingRecord.shippingDestinationsHarvestRecordData
    this.shippingRecordHarvestRecords = this.shippingRecord.shippingRecordHarvestRecords
      this.shippingRecord.shippingDestinations.forEach((destination => {
        destination.shippingDestinationDetails = destination.shippingDestinationDetails.map(item => {
          return {
            ...item,
            selectedWeightUnit: item.weightUnitId ? this.getWeightUnit(item.weightUnitId) : this.defaultWeightUnit
          }
        })
      }))
      this.recordInfo = {
        createdUser: this.shippingRecord.createdUser,
        created: this.shippingRecord.created,
        updatedUser: this.shippingRecord.updatedUser,
        updated: this.shippingRecord.updated
      }
      let workerInputTypeIsTimePoint
      if(this.shippingRecord.workers?.length) {
          workerInputTypeIsTimePoint = this.shippingRecord?.workers
          .map(w => 
            w.actualStartWorktime !== null && w.actualEndWorktime !==null && w.actualRestTime!==null
            ).reduce((res, b) => 
            res && b
            )
          }
      this.workerInputType = workerInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'
      let machineInputTypeIsTimePoint
      if(this.shippingRecord.machines.length) {
          machineInputTypeIsTimePoint = this.shippingRecord.machines
              .map(m => m.startWorktime !== null && m.endWorktime !== null && m.restTime !== null)
              .reduce((res, b) => res && b)
      }
      this.machineInputType = machineInputTypeIsTimePoint ? 'TIME_POINT' : 'TIME_INTERVAL'
    })
    .catch(()=>{
      this.$toasted.error('データの取得に失敗しました。')
    })
  }

  getPlantingWeightUnitId(){
      const  plantingId =this.shippingRecord.harvestRecords &&  this.shippingRecord.harvestRecords.length >0 ? this.shippingRecord.harvestRecords[0].planting.id :this.shippingRecord.planting?.id
        this.$apiClient.doRequest('get', `/plantings/${plantingId}`)
        .then((res)=>{
            this.plantingBasicUnitId =  res.basic_unit_id
              this.setDefaultWeightUnit();
            });
          }
          
  setDefaultWeightUnit(){
    const getWeightunit = this.weightUnits.find(item=> item.id == this.plantingBasicUnitId && item.isHidden === false) ?? this.defaultWeightUnit;
    this.shippingRecord.shippingDestinations?.forEach(destination => {
      const prevState = destination?.shippingDestinationDetails?.map((detail, index) => ({index, value: detail?.selectedWeightUnit?.name}));
      destination?.shippingDestinationDetails?.forEach((detail, index) => {
        if (this.plantingBasicUnitId && !detail.shippingRecordDestinationId && !detail.selectedWeightUnit?.id) {
          const exWeightName = ((prevState.length - 1) == index) ? getWeightunit?.name : prevState?.find(ele => ele?.index == index)?.value;
          const isKg = exWeightName == 'kg';
          detail.selectedWeightUnit = {
            id: isKg ? null : getWeightunit?.id || null,
            name: isKg ? 'kg' : getWeightunit?.name || 'kg',
            weightPerUnit: isKg ? 1 : getWeightunit?.weightPerUnit || null,
            isHidden: false
          };
        }
      });
    });
  }

  get filterMeasurementTimings() {
    return this.measurementTimings
      .filter(m => this.measurementTimingId == m.id || m.isHidden === false)
}

  async getQualityStandards() {
    return this.$apiClient.doRequest('get', '/quality_standards?with_hidden=true')
    .then((res: QualityStandardResponse)=>{
      this.qualityStandards = (toCamel(res) as QualityStandards).qualityStandards
    })
    .catch(()=>{
      this.$toasted.error('データの取得に失敗しました。')
    })
  }

  async getWeightUnits() {
    return this.$apiClient.doRequest('get', '/weight_units?with_hidden=true')
    .then((res: WeightUnitResponse)=>{
      this.weightUnits = (toCamel(res) as WeightUnits).weightUnits
    })
    .catch(()=>{
      this.$toasted.error('データの取得に失敗しました。')
    })
  }

  private getPreferredWorkOption() {
    this.$apiClient.doRequest('get', `/graphScreenManagement/SHIPPINGRECORD`).then(ret => {
      this.shippingRecord.workRecordOption = ret.workRecordOption
    })
  }

  private editMeasurementTiming() {
    this.editModalBaseUrl = '/measurement_timings'
    this.$emit('shipping-edit-modal',true);
    this.showEditModal = true
  }

  @Watch('showEditModal')
  onMeasuremtTimingsModal(val: boolean) {
    this.$emit('shipping-edit-modal', val)
  }

  deleteHarvestRecord(index: number) {
    this.isHarvestChanged = true;
    this.shippingRecord.harvestRecords?.splice(index, 1)
    this.harvestQualityStandards = [];
    this.harvestRemainings = [];
    this.formattedHarvestRemainings = '';
    if (this.shippingRecord.harvestRecords?.length) {
      this.formHarvestQualityStandards(this.shippingRecord.harvestRecords);
    }
    else{
      this.harvestQualityStandards =  this.qualityStandards;
      this.shippingRecord.shippingDestinations?.forEach((ele) => {
        ele?.shippingDestinationDetails?.forEach((item) => {
          if(item.harvestQualityStandardId && item.shippingRecordDestinationId){
           return;
          }
          else{
            item.harvestQualityStandardId = null;
          }
          });
        }); 
      this.setDefaultWeightUnit();
    }
  }

  deletePlantingRecord() {
    this.isHarvestChanged = true;
    this.shippingRecord.planting = null
    this.shippingRecord.agriField = null
    if(!this.shippingRecord.planting){
      this.plantingBasicUnitId =null
      this.harvestQualityStandards = []
    }
    this.setDefaultHavestQualityStandard();
    this.setDefaultWeightUnit();
    this.isChecked=false;
    this.isCheckDisable=false;
  }

  deleteDestination(index: number) {
    const records = this.shippingRecord.shippingDestinations[index].shippingDestinationDetails;
    this.deletedShippingDetailIds.push(
      ...records?.map(record => record.shippingRecordDestinationId)
                .filter((id): id is string => id !== null) || []
    );
    this.shippingRecord.shippingDestinations?.splice(index, 1)
    this.formRemainingQuantityLabel();
  }

  @Watch("showDestinationModal")
  callHarvestQualityStandards() {
    this.setDefaultWeightUnit();
    this.setDefaultHavestQualityStandard()
  }
  
  addDestinationDetail(sd:ShippingRecordDestination) {
    sd.shippingDestinationDetails.push(Object.assign({}, this.defaultDestinationDetail))
    this.inputChanged()
    this.setDefaultHavestQualityStandard()
    this.setDefaultWeightUnit();
  }

  deleteDestinationDetail(sd:ShippingRecordDestination, index: number) {
    const record = sd.shippingDestinationDetails[index];
    if(record.shippingRecordDestinationId) this.deletedShippingDetailIds.push(record.shippingRecordDestinationId);
    sd.shippingDestinationDetails.splice(index, 1)
    this.inputChanged()
    this.formRemainingQuantityLabel();
  }



  calcAmount(detail: ShippingDestinationDetailItem) {
    if(!this.isAutoCalc) {
      return false
    }
    if(!detail.quantity || !detail.unitPrice) {
      detail.amount = null
    } else {
      const calc = detail.quantity * detail.unitPrice
      detail.amount = Math.round(calc)
    }
    this.inputChanged()
  }

  

  calcUnitPrice(detail: ShippingDestinationDetailItem) {
    this.formRemainingQuantityLabel();
    if (!this.isAutoCalc) {
        return false;
    }
        if (!detail.quantity || detail.quantity == 0 || !detail.amount) {
            detail.unitPrice = null;
        } else {
            const unitPrice = detail.amount / detail.quantity;
            detail.unitPrice = Math.round(unitPrice * 100) / 100;
        }

        this.inputChanged();
}

  calcQuantityPerWeight(detail: ShippingDestinationDetailItem) {
    if(!detail.quantity || !detail.selectedWeightUnit?.id || !detail.selectedWeightUnit?.weightPerUnit) {
      return ''
    }
    const calc = detail.quantity * detail.selectedWeightUnit.weightPerUnit
    return Math.round(calc * 1000) / 1000
  }

  calcAmountPerWeight(detail: ShippingDestinationDetailItem) {
    if(!detail.amount || !detail.selectedWeightUnit?.id || !detail.selectedWeightUnit?.weightPerUnit) {
      return ''
    }
    const quantity = this.calcQuantityPerWeight(detail)
    const calc = detail.amount / Number(quantity)
    return Math.round(calc * 100) / 100
  }

  getWeightUnit(id: string) {
    if(!id) {
      return this.defaultWeightUnit
    }
    const unit = this.weightUnits.find(unit => unit.id == id)
    return unit ? unit : this.defaultWeightUnit
  }

  isWeightPerUnit(detail: ShippingDestinationDetailItem) {
    return detail.quantity && detail.selectedWeightUnit?.id && detail.selectedWeightUnit.weightPerUnit
  }

//   // 収穫記録から選択モーダル
  openHarvestModal() {
    this.selectedShippingTarget = {
      harvestRecordId: this.shippingRecord.harvestRecords?
          this.shippingRecord.harvestRecords.map(record => record.id) : [],
      agriFieldId: this.shippingRecord.agriField?.id ?? null,
      plantingId: this.shippingRecord.planting?.id ?? null
    }
    this.showSelectFromHarvestRecord = true
    // this.selectMeasurementTiming = false
    this.isChecked = false
  }
  // 収穫記録選択モーダルからのコールバック
  async commitHarvestRecords(harvestRecords: ShippingRecordHarvestRecord[]) {
    this.isHarvestChanged = true;
    await Promise.all(harvestRecords.sort((a, b) => a.harvestDate.localeCompare(b.harvestDate)).map(async (record) => {
      const res = await this.getHarvestQualityData(record.id);
      const updatedRecord = { ...record, qualityData: res };
      Object.assign(record, updatedRecord);
    }));
    this.formHarvestQualityStandards(harvestRecords);
    this.shippingRecord.harvestRecords = harvestRecords
    this.shippingRecord.shippingType = 'HARVEST_RECORD'
    this.showSelectFromHarvestRecord = false
    this.shippingRecord.planting = harvestRecords[0].planting
    this.shippingRecord.agriField = harvestRecords[0].agriField
    this.getPlantingWeightUnitId(); 
  }

  async getHarvestQualityData (id: string) {
    let result = '';
    const aggregatedData: any[] = [];
    const res = await this.$apiClient.doRequest('get', `/harvest_records/${id}`);
    res.harvest_record_data.forEach((data: { quality_standard_id: string; quality_standard_name: string; weight_unit_id: string|null; quantity: number|null; remaining_quantity:number|null , weight_per_unit: number|null}) => {
      if (data.quantity != null && data.quantity != undefined) {
        const existingDetail = aggregatedData.find(item => item.quality_standard_id === data.quality_standard_id);
        const wpu = data.weight_unit_id != null ? data.weight_per_unit : 1;
        if (wpu != null) {
          if (existingDetail) {
            existingDetail.quantity += (data.quantity * wpu);
            existingDetail.remaining_quantity += (data.remaining_quantity != null ? data.remaining_quantity * wpu : data.quantity * wpu);
          } else {
            aggregatedData.push({
              quality_standard_id: data.quality_standard_id,
              quality_standard_name: data.quality_standard_name,
              quantity: data.quantity * wpu,
              remaining_quantity : data.remaining_quantity != null ? data.remaining_quantity * wpu : data.quantity * wpu,
              isWpuAvailable: true
            });
          }
        } else {
          if (existingDetail) {
            existingDetail.isWpuAvailable = false;
          } else {
            aggregatedData.push({
              quality_standard_id: data.quality_standard_id,
              quality_standard_name: data.quality_standard_name,
              quantity: 0,
              remaining_quantity : 0,
              isWpuAvailable: false
            });
          }
        }
      }
    });
    aggregatedData.sort((a, b) => a.quality_standard_name.localeCompare(b.quality_standard_name)).forEach((item, index) => {
      const quantityText = item.isWpuAvailable ? `${this.formatDigit(item.quantity)}kg` : `<span style="color: red;" class="tooltip">単位未設定</span>`;
      const remainingQuantityText = item.isWpuAvailable ? `(${this.formatDigit(item.remaining_quantity)}kg)` : `<span style="color: red;" class="tooltip">(単位未設定)</span>`;
      result += `${item.quality_standard_name}: ${quantityText}${remainingQuantityText}`;
      if (index < aggregatedData.length - 1) {
        result += " / ";
      }
    });
    return result;
  }

  async formHarvestQualityStandards(harvestRecords: ShippingRecordHarvestRecord[]) {
    this.harvestQualityStandards = [];
    this.harvestRemainings = [];
    const harvestRecordIds = harvestRecords.map(record => record.id);
    const params = {
      harvest_record_ids: harvestRecordIds,
      shipping_record_id: this.shippingRecordId
    };
    const api = '/harvest_records/detail';
    try {
      const response = await this.$apiClient.doRequest('post', api, params);
      this.harvestRemainings = response;
      const harvestQualityStandards: QualityStandard[] = response.map((item: { quality_standard_id: string; quality_standard_name: string; }) => ({
        id: item.quality_standard_id,
        name: item.quality_standard_name,
        isHidden: false
      }));
      this.harvestQualityStandards = harvestQualityStandards;
      this.setDefaultHavestQualityStandard()
      this.formRemainingQuantityLabel();
    } catch (error) {
      this.$toasted.error('データの取得に失敗しました。');
    }
  }

  setDefaultHavestQualityStandard(){
    const harvestQualityStandardsIds = this.harvestQualityStandards?.map((ele)=> ele.id);
    const defaultHarvestQualityStandardId = (this.harvestQualityStandards.length === 1) ? this.harvestQualityStandards[0].id : null;
    this.shippingRecord.shippingDestinations?.forEach((ele) => {
      ele?.shippingDestinationDetails?.forEach((item) => {
        if (!item.harvestQualityStandardId && !item.shippingRecordDestinationId) {
          item.harvestQualityStandardId = defaultHarvestQualityStandardId;
        }
        else if(item.harvestQualityStandardId){
          const isValidId = harvestQualityStandardsIds?.includes(item.harvestQualityStandardId);
          if (!isValidId) {
            item.harvestQualityStandardId = harvestQualityStandardsIds.length == 1 ? harvestQualityStandardsIds[0] : null;
          }
        }
      });
    });
    
  }


  formRemainingQuantityLabel(flag = false) {
    if (flag) {
      this.inputChanged();
    }
    this.formattedHarvestRemainings = '';
    const aggregatedData: any[] = [];
    this.shippingRecord.shippingDestinations.forEach(destination => {
      destination.shippingDestinationDetails.forEach(detail => {
        if (detail.harvestQualityStandardId != null && detail.quantity != null) {
          const weightPerUnit = detail.selectedWeightUnit?.weightPerUnit;
          if (weightPerUnit != null || weightPerUnit != undefined) {
            const existingDetail = aggregatedData.find(item => item.quality_standard_id === detail.harvestQualityStandardId);
            if (existingDetail) {
              existingDetail.quantity += (detail.quantity * weightPerUnit);
            } else {
              aggregatedData.push({
                quality_standard_id: detail.harvestQualityStandardId,
                quantity: detail.quantity * weightPerUnit,
              });
            }
          }
        }
      });
    });
    const quantityToReduceMap: { [key: string]: number } = {};
    aggregatedData.forEach(entry => {
      quantityToReduceMap[entry.quality_standard_id] = entry.quantity;
    });
    this.harvestRemainings.forEach((item: { quality_standard_id: string; quality_standard_name: string; remaining_quantity: number; is_wpu_available: boolean }, index: number) => {
      let quantity = item.remaining_quantity || 0;
      if (Object.prototype.hasOwnProperty.call(quantityToReduceMap, item.quality_standard_id)) {
        quantity -= quantityToReduceMap[item.quality_standard_id];
      }
      const quantityText = item.is_wpu_available ? `${this.formatDigit(quantity)}kg` : `<span style="color: red;" class="tooltip">単位未設定</span>`;
      this.formattedHarvestRemainings += `${item.quality_standard_name}: ${quantityText}`;
      if (index < this.harvestRemainings.length - 1) {
        this.formattedHarvestRemainings += " / ";
      }
    });
  }

//   // 作付選択モーダル表示
  openPlantingModal() {
    this.selectedShippingTarget.agriFieldId = this.shippingRecord.agriField? this.shippingRecord.agriField.id : null
    this.selectedShippingTarget.plantingId = this.shippingRecord.planting? this.shippingRecord.planting.id : null
    this.showSelectFromPlantings = true
  }

//   // 作付選択モーダルからのコールバック
  commitPlantingAndField(selectedItem: SelectAgriFieldAndPlanting) {
    this.isHarvestChanged = true;
    this.shippingRecord.planting = {
      id: selectedItem.planting.id,
      name: selectedItem.planting.name
    }
    this.shippingRecord.agriField = {
      id: selectedItem.agriField.id,
      name: selectedItem.agriField.name
    }
    this.shippingRecord.harvestRecords = null
    this.shippingRecord.shippingType = 'PLANTING'
    this.showSelectFromPlantings = false
    this.shippingRecord.shippingDestinations.forEach(destination => {
      destination.shippingDestinationDetails.forEach(detail => {
        detail.harvestQualityStandardId = null;
      });
    });
    this.harvestQualityStandards = this.qualityStandards.filter(qs => qs.isHidden === false)
    this.getPlantingWeightUnitId();
  }

//   // 出荷先選択モーダル表示
  openDestinationModal() {
    this.selectedDestinations = this.shippingRecord.shippingDestinations.map(destination => {
      return {
        id: destination.id,
        name: destination.name,
        isHidden: false
      }
    })
    this.showDestinationModal = true
  }
  
  getWeightPerUnit(weightUnitId: string | null): number | null {
    const weightUnit = this.weightUnits.find(item => item.id === weightUnitId);
    if (weightUnit && weightUnit.weightPerUnit !== null) {
        return weightUnit.weightPerUnit;
    } else {
        return null;
    }
}

  calculateAdjustedQuantity(quantity: any,weightPerUnit: number |null): number {
    if (weightPerUnit === null) {
        return quantity;
    } else {
        return quantity * weightPerUnit;
    }
}

//   // 出荷先選択モーダルからのコールバック
  commitDestinations(shippingDestinations: ShippingDestination[]) {
    let destinations = this.shippingRecord.shippingDestinations
    const removedDestinations = destinations.filter(sd => !shippingDestinations.some(item => item.id === sd.id));
    this.deletedShippingDetailIds.push(
      ...removedDestinations.flatMap(dest =>
        (dest.shippingDestinationDetails || [])
          .map(d => d.shippingRecordDestinationId)
          .filter((id): id is string => !!id)
      )
    );
    // チェックが外れたものを取り除く
    destinations = destinations.filter(sd => {
      return shippingDestinations.some(item => item.id == sd.id)
    })
    // モーダルから返却されたもので更新する
    this.shippingRecord.shippingDestinations = shippingDestinations.map(sd => {
      const shippingDestinationDetails = destinations.find(destination => destination.id === sd.id)?.shippingDestinationDetails
      const newShippingDestinationDetails = [Object.assign({}, this.defaultDestinationDetail)]
        return  {
          id: sd.id,
          name: sd.name,
          shippingDestinationDetails: shippingDestinationDetails ? shippingDestinationDetails : newShippingDestinationDetails
        }
    })
    this.formRemainingQuantityLabel();
  }

//   // 出荷先選択モーダルで出荷先が更新される
  updateShippingDestination(shippingDestination: ShippingDestination) {
    if (this.shippingRecord.shippingDestinations.length) {
      this.shippingRecord.shippingDestinations.forEach(item => {
        if (item.id === shippingDestination.id) {
          item.name = shippingDestination.name
        }
      })
    }
  }

  // 編集モーダル表示
  private editWeightUnits() {
    this.editModalBaseUrl = '/weight_units'
    this.showEditModal = true
  }

  private editQualityStandards() {
    this.editModalBaseUrl = '/quality_standards'
    this.showEditModal = true
  }

//   // 編集モーダルからのコールバック
  private async updateItems(baseUrl: string) {
    switch (baseUrl) {
      case '/weight_units':
        this.getWeightUnits().then(() => {
          for(const shippingDestination of this.shippingRecord.shippingDestinations) {
            shippingDestination.shippingDestinationDetails.map(detail => {
              const selectedWeightUnit = this.weightUnits.find(weightUnit => weightUnit.id == detail.selectedWeightUnit?.id)
              detail.selectedWeightUnit = selectedWeightUnit ? selectedWeightUnit : this.defaultWeightUnit
            })
          }
        })
        break
      case '/quality_standards':
        await this.getQualityStandards()
        break
    }
  }

//   // 編集モーダルのクローズ
  private closeEditModal() {
    this.showEditModal = false
  }

//   // 入力チェック
  validation(): boolean {
    const errmsg: string[] = []

    // 出荷日
    if(!this.shippingRecord.shippingDate) {
      errmsg.push('出荷日を選択してください')
    }

    // 出荷対象
    if(this.shippingRecord.shippingType == 'HARVEST_RECORD') {
      if(this.shippingRecord.harvestRecords == null || this.shippingRecord.harvestRecords.length == 0) {
        errmsg.push('出荷対象を選択してください')
      }
    } else {
      if(this.shippingRecord.planting == null || this.shippingRecord.agriField == null) {
        errmsg.push('出荷対象を選択してください')
      }
    }
    if(this.shippingRecord.shippingType == 'PLANTING' && this.isChecked){
     // 計測タイミング
     if(!this.measurementTimingId) {
      errmsg.push('計測タイミングを選択してください。')
    }
    }

    //作業記録内容
    if(this.shippingRecord.workRecordOption == 'LINKWORK' && this.workRecordId == '') {
      errmsg.push('紐づける作業記録を選択してください。')
    }

    if (this.shippingRecord.workers.length > 0) {
      this.shippingRecord.workers.forEach(worker => {
        if (worker.memo && worker.memo.length > 21844) {
          errmsg.push(`メモは21844文字以内で入力してください。（現在は${worker.memo.length}文字, 作業者：${worker.worker.name}）`)
        }
      })
    }
  
    if (this.shippingRecord.machines.length > 0) {
      this.shippingRecord.machines.forEach(machine => {
        if (machine.memo && machine.memo.length > 21844) {
          errmsg.push(`メモは21844文字以内で入力してください。（現在は${machine.memo.length}文字, 機械：${machine.machine.name}）`)
        }
      })
    }

    // 出荷先
    if(this.shippingRecord.shippingDestinations == null || this.shippingRecord.shippingDestinations.length == 0) {
      errmsg.push('出荷先を選択してください')
    } else {
      this.shippingRecord.shippingDestinations.forEach(destination => {
        if(destination.shippingDestinationDetails.length == 0) {
          errmsg.push(`明細が入力されていません(出荷先：${destination.name})`)
        }
        destination.shippingDestinationDetails.forEach(detail => {
          if(detail.qualityStandardId === "" || detail.qualityStandardId === null) {
            errmsg.push(`出荷(品質・規格)を選択してください(出荷先：${destination.name})`)
          }
          if(!detail.quantity) {
            errmsg.push(`明細に数量を入力してください(出荷先：${destination.name})`)
          }else if(detail.quantity==0){
            errmsg.push(`明細に数量を入力してください(出荷先：${destination.name})`)
          } else {
            const quantityStr = detail.quantity.toString().split('.')
            if(detail.quantity < 0 || quantityStr[0].length > 7 || (quantityStr[1] && quantityStr[1].length > 2)) {
              errmsg.push(`数量は0以上の整数部7桁小数部2桁までの数値を入力してください(出荷先：${destination.name})`)
            }
          }
          if(detail.amount && (detail.amount < 0 || !Number.isInteger(Number(detail.amount)))) {
            errmsg.push(`金額は0以上の整数を入力してください(出荷先：${destination.name})`)
          }
          if(detail.unitPrice) {
            const unitStr = detail.unitPrice.toString().split('.')
            if(detail.unitPrice < 0 || unitStr[0].length > 7 || (unitStr[1] && unitStr[1].length > 2)) {
              errmsg.push(`単価は0以上の整数部7桁小数部2桁までの数値を入力してください(出荷先：${destination.name})`)
            }
          }
          if(detail.memo && detail.memo.length > 21844) {
            errmsg.push(`備考は21844文字以内で入力してください（現在は${detail.memo.length}文字, 出荷先：${destination.name}）`)
          }
        })
      })
    }
    // メモ
    if(this.shippingRecord.memo && this.shippingRecord.memo.length > 21844) {
      errmsg.push(`メモは21844文字以内で入力してください（現在は${this.shippingRecord.memo.length}文字）`)
    }

    if(errmsg.length > 0) {
      window.alert(errmsg.join('\n'))
      return false
    }

    return true
  }

  // refsで呼ばれるフッターボタン
  async saveRecord() {
    if (this.shippingRecord.workRecordOption == "WITHOUTWORK") {
      this.shippingRecord.workers = []
      this.shippingRecord.machines = []
    }
    if(!this.validation()) {
      return false
    }
    const { data, harvestQualityStandardAlert } =
    this.buildShippingRecordPayload();
    if (((this.shippingRecord.shippingType == 'PLANTING' && this.isChecked) || (this.shippingRecord.shippingType == 'HARVEST_RECORD')) && this.isValidationNeeded && harvestQualityStandardAlert && !window.confirm("収穫（品質・規格）が未選択の出荷データが存在しますが、\nこのまま保存してよろしいでしょうか？")) {
      return false
    }
    let method: "get" | "post" | "put" | "delete" = 'post'
    let url = this.apiBaseUrl
    let message = '保存しました。'
    this.updateProcessType(data);
    if(this.modeType == 'edit') {
      method = 'put'
      url = `${this.apiBaseUrl}/${this.shippingRecordId}`
      message = '変更を保存しました。'
      if(this.isValidationNeeded && !window.confirm("内容を上書きして保存します。よろしいですか。")) {
        return false
      }
    }
    this.isLoading = true;
    return this.doRequest(method, url, data)
    .then((res)=>{
        if (res.message != null) {
            window.alert(this.alertMessage + res.message);
            this.isLoading = false;
            this.$toasted.error('変更に失敗しました。')
            return;
        }
        this.isValidationNeeded = true;
        this.$emit('update:isRefresh', true);
        this.$emit('update:isCollectiveListRefresh', true);
        this.$store.dispatch('doUpdateIsInputChanged', false);
        this.$toasted.success(message)
        this.isLoading = false;
        if(this.$route.query.return_to){
        this.$root.$emit('header-inert', false);
        this.$router.push(`/${this.$route.query.return_to}?date=${this.shippingRecord.shippingDate}`, () => {return})
        }else {
        this.closeModal();
        this.isChecked = false
        this.init()
        if(this.shippingRecordId) {
            this.getShippingRecord(this.shippingRecordId)
        }
        }
    })
  }

  public async doRequest(method: "get"|"post"|"put"|"delete", url: string, params?: any) {
    const accessToken = store.getters.accsessToken
    const tenantId = this.$apiClient.getTenantId() || store.getters.tenantId;
    const config: AxiosRequestConfig = {
      url: `${this.apiServerBaseUrl}${url}`,
      method: method,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`,
        'agri-tenant-id': tenantId
      },
      data: params,
      withCredentials: true
    }
    try {
      const res = await axios(config);
      return res.data;
    } catch (error) {
      if (error.response.status === 401) {
        await this.$apiClient.getAccessToken()
      }
      if (error.response.status === 400 && error.response.data?.message?.includes("保存しますか？")) {
        const result = window.confirm(error.response.data?.message)
        if (result) {
          this.isValidationNeeded = false;
          this.saveRecord();
        } else {
          this.isLoading = false;
          this.isValidationNeeded = true;
          this.$toasted.success('保存がキャンセルされました。')
        }
        Promise.reject(error.response);
      } else {
        this.$toasted.error(this.modeType === 'edit' ? '変更に失敗しました。' : '保存に失敗しました。')
        this.isLoading = false;
        this.isValidationNeeded = true;
        this.$apiClient.errorAlert(error.response.status, error.response.data?.message)
      }
      return Promise.reject(error.response)
    }
  }

  async deleteRecord() {
     const { data } = this.buildShippingRecordPayload();
    const confirm = window.confirm('削除しますか？')
    if(confirm) {
      this.isLoading = true;
      return this.$apiClient.doRequest('delete', `${this.apiBaseUrl}/${this.shippingRecordId}`,data)
      .then((res)=>{
        if (res.message != null) {
            window.alert(this.alertMessage + res.message);
            this.isLoading = false;
            this.$toasted.error('削除に失敗しました。')
            return;
        }
        this.shippingRecordId = "";
        this.workRecordId = "";
        this.$emit('update:isRefresh', true);
        this.isLoading = false;
        this.$toasted.success('削除しました。')
        this.closeModal();
      })
      .catch(()=>{
        this.isLoading = false;
        this.$toasted.error('削除に失敗しました。')
      })
    } else {
      this.$toasted.success('削除がキャンセルされました。')
    }

  }

  private buildShippingRecordPayload(): {data: ShippingRecordPostModel;harvestQualityStandardAlert: boolean;} {
      const harvestQualityStandardAlert = false;

      const shippingDestinations = this.shippingRecord.shippingDestinations.map(
        destination => {
          const shippingDestinationDetails =
          destination.shippingDestinationDetails.map(detail => ({
            shippingDetailId: detail.shippingRecordDestinationId,
            quality_standard_id: detail.qualityStandardId,
            harvest_quality_standard_id: detail.harvestQualityStandardId,
            quantity: detail.quantity,
            weight_unit_id: (detail.selectedWeightUnit?.id || detail.selectedWeightUnit?.id === null) ? detail.selectedWeightUnit.id : detail.weightUnitId,
            amount: detail.amount,
            unit_price: detail.unitPrice,
            memo: detail.memo,
            shipping_split_id: detail.shippingSplitId ?? null,
            shipping_collective_id: detail.shippingCollectiveId ?? null,
            processType: detail.processType ?? "NOCHANGE",
            updated: detail.updated
          }));

          return {
            shipping_destination_id: destination.id,
            shipping_destination_details: shippingDestinationDetails
          };
        }
      );

      const deletedWorkers = this.originalWorkers.filter(
        w =>
          !this.shippingRecord.workers.some(
            worker => worker.worker.id === w.worker.id
          )
      );

      const deletedMachines = this.originalMachines.filter(
        m =>
          !this.shippingRecord.machines.some(
            machine => machine.machine.id === m.machine.id
          )
      );
    const deletedShippingDetails = this.originalShippingDetails
    .flatMap(destination =>
    destination.shippingDestinationDetails
      .filter(detail =>
        detail.shippingRecordDestinationId &&
        this.deletedShippingDetailIds.includes(detail.shippingRecordDestinationId)
      )
      .map(detail => ({
        shipping_record_data_id: detail.shippingRecordDestinationId!,
        updated: detail.updated
      }))
    );

      const data: ShippingRecordPostModel = {
        shipping_date: this.shippingRecord.shippingDate,
        isChecked: this.isChecked,
        isValidationNeeded: this.isValidationNeeded,
        shipping_type: this.shippingRecord.shippingType,
        measurement_timing_id: this.measurementTimingId,
        harvest_record_id:
          this.shippingRecord.harvestRecords?.length
            ? this.shippingRecord.harvestRecords.map(r => r.id)
            : null,
        planting_id: this.shippingRecord.planting?.id ?? null,
        agri_field_id: this.shippingRecord.agriField?.id ?? null,
        work_record_id: this.workRecordId ?? "",
       
        workers: this.shippingRecord.workers.map(w => {
            const originalWorker = this.originalWorkers.find(orig => orig.worker.id === w.worker.id)
            const workerUpdatedTime = (w.workerUpdatedTime && w.workerUpdatedTime !== "") 
                ? w.workerUpdatedTime 
                : originalWorker?.workerUpdatedTime ?? ""
            return {
                worker_id: w.worker.id,
                start_worktime: w.startWorktime,
                plan_start_worktime: w.planStartWorktime,
                actual_start_worktime: w.startWorktime,
                end_worktime: w.endWorktime,
                plan_end_worktime: w.planEndWorktime,
                actual_end_worktime: w.endWorktime,
                rest_time: w.restTime ?? 0,
                plan_rest_time: w.planRestTime ?? 0,
                actual_rest_time: w.restTime ?? 0,
                work_time: w.workTime,
                plan_work_time: w.planWorkTime,
                actual_work_time: w.workTime,
                kind: "ACTUAL",
                memo: w.memo,
                processType: "NOCHANGE",
                worker_updated_time: workerUpdatedTime
            }
        }),
        deletedWorkers: deletedWorkers.map(w => w.worker.id),
        deletedWorker: deletedWorkers.map(w => ({
          worker_id: w.worker.id,
          worker_updated_time: w.workerUpdatedTime
        })),
        machines: this.shippingRecord.machines.map(m => {
            const originalMachine = this.originalMachines.find(orig => orig.machine.id === m.machine.id)
            const machineUpdatedTime = (m.machineUpdatedTime && m.machineUpdatedTime !== "")
                ? m.machineUpdatedTime
                : originalMachine?.machineUpdatedTime ?? ""
            return {
                machine_id: m.machine.id,
                start_worktime: m.startWorktime,
                end_worktime: m.endWorktime,
                rest_time: m.restTime ?? 0,
                work_time: m.workTime,
                memo: m.memo,
                processType: "NOCHANGE",
                machine_updated_time: machineUpdatedTime
            }
        }),
        deletedMachines: deletedMachines.map(m => m.machine.id),
        deletedMachine: deletedMachines.map(m => ({
          machine_id: m.machine.id,
          machine_updated_time: m.machineUpdatedTime
        })),
        deletedShippingDetailIds: this.deletedShippingDetailIds,
        deleted_shipping_details: deletedShippingDetails,
        shipping_destinations : shippingDestinations,
        lot_number: this.shippingRecord.lotNumber,
        memo: this.shippingRecord.memo,
        workRecordOption: this.shippingRecord.workRecordOption,
        isHarvestChanged: this.isHarvestChanged,
        updated_shipping_time: this.shippingRecord.updatedShippingTime,
        work_record_updated : this.workRecordUpdated,
        shipping_record_work_records_updated : this.shippingRecord.shippingRecordWorkRecordsUpdated,
        shipping_destination_harvest_record_data : this.shippingRecord.shippingDestinationsHarvestRecordData,
        shipping_record_harvest_records : this.shippingRecord.shippingRecordHarvestRecords,
      };

    return { data, harvestQualityStandardAlert };
  }

  private filterWeightUnitsByDetail(detail: ShippingDestinationDetailItem) {
    const selectedWeightUnit = detail.selectedWeightUnit;
    return this.weightUnits.filter(wu => (selectedWeightUnit?.id == wu.id || detail.weightUnitId == wu.id) || wu.isHidden === false)
  }

  private filterQualityStandardsByDetail(detail: ShippingDestinationDetailItem) {
    return this.qualityStandards
      .filter(qs => detail.qualityStandardId == qs.id || qs.isHidden === false)
  }

  @Emit('inputChanged')
  private inputChanged(){
    if(store.getters.isInputChanged==false){
    this.$store.dispatch('doUpdateIsInputChanged', true);
    }
  }

  cancelRecord() {
    if (this.$store.getters.isInputChanged) {
      const result = window.confirm('変更内容を破棄します。よろしいですか。');
      if (!result) {
          return false;
      }
    }
    this.$store.dispatch('doUpdateIsInputChanged', false);
    if (this.shippingRecordId !== undefined && this.shippingRecordId !== ''){
      this.getShippingRecord(this.shippingRecordId);
    }else{
      this.init()
    }
  }


  deleteWorker(index: number,workerId:string): void {
    this.shippingRecord.workers.splice(index, 1)
    this.inputChanged()
}

deleteMachine(index: number): void {
    this.shippingRecord.machines.splice(index, 1)
    this.inputChanged()
}

private initializeMachines(machines: Machine[]) {
    return machines.map(m => ({
        ...m.machine,
        isHidden: false,
    }))
}

private initializeWokers(workers: Worker[]) {
    return workers.map(w => ({
        ...w.worker,
        isHidden: false,
    }))
}

private openWorkerSelectTime(idx: number | 'all') {
    const isTime = this.workerInputType === 'TIME_POINT'
    if (isTime) {
        this.showSelectTime = true
    } else {
        this.showSelectInterval = true
    }
    this.selectTimeIndex = idx
    if(typeof idx === 'number') {
        const worker = this.shippingRecord.workers[idx]
        // 既に作業時間（時刻の時は＋開始・終了時間）が入っているときはそれを初期値とする
        if(worker.workTime > 0 && (!isTime || (worker.startWorktime && worker.endWorktime))) {
            this.targetSelectTime = {
                startWorktime: worker.startWorktime,
                endWorktime: worker.endWorktime,
                restTime: worker.restTime,
                workTime: worker.workTime,
            }
        }
    }
    this.workerOrMachine = 'WORKER'
    this.inputChanged()
}

private openMachineSelectTime(idx: number | 'all') {
    if (this.machineInputType === 'TIME_POINT') {
        this.showSelectTime = true
    } else {
        this.showSelectInterval = true
    }
    this.selectTimeIndex = idx
    if(typeof idx === 'number') {
        const machine = this.shippingRecord.machines[idx]
        // 既に作業時間が入っているときはそれを初期値とする
        if(machine.workTime > 0) {
            this.targetSelectTime = {
                startWorktime: machine.startWorktime,
                endWorktime: machine.endWorktime,
                restTime: machine.restTime,
                workTime: machine.workTime
            } as WorkTimeState
        }
    }
    this.workerOrMachine = 'MACHINE'
    this.inputChanged()
}

private commitTime(value: WorkTimeState) {
  if (this.workerOrMachine === 'WORKER') {
      if (typeof this.selectTimeIndex === 'number') {
          const worker = this.shippingRecord.workers[this.selectTimeIndex]
          this.shippingRecord.workers[this.selectTimeIndex] = { ...worker, ...value }
      } else if (this.selectTimeIndex === 'all') {
          this.shippingRecord.workers = this.shippingRecord.workers.map(w => ({ ...w, ...value }))
      }
  } else if (this.workerOrMachine === 'MACHINE') {
      if (typeof this.selectTimeIndex === 'number') {
          const machine = this.shippingRecord.machines[this.selectTimeIndex]
          this.shippingRecord.machines[this.selectTimeIndex] = { ...machine, ...value }
      } else if (this.selectTimeIndex === 'all') {
          this.shippingRecord.machines = this.shippingRecord.machines.map(m => ({ ...m, ...value }))
      }
  }
  this.targetSelectTime = value
}

private commitWorkers(value: { id: string, name: string }[]) {
    const existingWorker = this.shippingRecord.workers.filter(w => value.find(v => v.id === w.worker.id) !== undefined)
    const newWorker: Worker[] = value
        .filter(v => this.shippingRecord.workers.find(w => w.worker.id === v.id) === undefined)
        .map(v => ({
            worker: v,
            startWorktime: null,
            planStartWorktime: null,
            actualStartWorktime: null,
            endWorktime: null,
            planEndWorktime: null,
            actualEndWorktime: null,
            restTime: null,
            planRestTime: null,
            actualRestTime: null,
            workTime: 0,
            planWorkTime: 0,
            actualWorkTime: 0,
            quantity:0,
            memo: "",
            kind :"SCHEDULE",
            workerUpdatedTime : ""
        }))
    this.shippingRecord.workers = [...existingWorker, ...newWorker]
}

private commitMachines(value: { id: string, name: string }[]) {
    const newMachines: Machine[] = value.map(v => {
        const existingMachine = this.shippingRecord.machines.find(m => m.machine.id === v.id)
        return {
            machine: v,
            startWorktime: existingMachine ? existingMachine.startWorktime : null,
            endWorktime: existingMachine ? existingMachine.endWorktime : null,
            restTime: existingMachine ? existingMachine.restTime : null,
            workTime: existingMachine ? existingMachine.workTime : 0,
            memo: existingMachine ? existingMachine.memo : "",
            machineUpdatedTime : existingMachine ? existingMachine.machineUpdatedTime : ""
        }
    })
    this.shippingRecord.machines = [...newMachines]
}

private updateMachine(value: Item) {
    this.shippingRecord.machines.forEach(item => {
        if (value && item.machine.id === value.id) {
            item.machine = value
        }
    })
}

private displayTime(time: string | null) {
    return time ? time.slice(0, 5) : ''
}

private minuteToHour(minute: number) {
    return minute ? Math.floor(minute / 60) + '時間' + minute % 60 + '分' : '0時間0分';
}

formatDigit(numberToFormat?: number): string {
  return typeof numberToFormat === 'number' ? 
  numberToFormat.toLocaleString(undefined, {
      minimumFractionDigits: (numberToFormat % 1 !== 0) ? 2 : 0,
      maximumFractionDigits: (numberToFormat % 1 !== 0) ? 2 : 0
  }) 
  : '';
}

openWorkRecordModal() {
  this.workMode = "edit";
  this.showWork = true;
}

closeWorkRecordModal() {
  this.workMode = null;
  this.showWork = false;
}

refreshShipping () {
  this.refresh = true;
  this.getShippingRecord(this.shippingRecordId);
}

private changeUnit(detail: ShippingDestinationDetailItem) {
  const selectedWeightUnit = detail.selectedWeightUnit;
  if (selectedWeightUnit && selectedWeightUnit.id != null && selectedWeightUnit.weightPerUnit === null) {
    window.alert(`単位「${selectedWeightUnit.name}」の1単位あたりの重量を設定してください。`);
    detail.selectedWeightUnit = this.defaultWeightUnit;
    return;
  }
  this.formRemainingQuantityLabel(true);
  this.setProcessType(detail);
}

setProcessType(detail: ShippingDestinationDetailItem) {
  detail.processType = detail.shippingRecordDestinationId ? 'UPDATE' : 'ADD';
  this.inputChanged();
}

toCamelCase = (str: string) => {
  return str.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
};

compareObject = (original: any, updated: any) => {
  const updatedKeys = Object.keys(updated);
  for (const key of updatedKeys) {
      const originalKey = this.toCamelCase(key);
      if (Object.prototype.hasOwnProperty.call(original, originalKey) && Object.prototype.hasOwnProperty.call(updated, key)) {
          if (original[originalKey] !== updated[key]) {
              return true;
          }
      }
  }
  return false;
};

updateProcessType(params: any ) {
  params.workers.forEach((worker: any) => {
      const originalWorker = this.originalWorkers.find(w => w.worker.id === worker.worker_id);
      if (originalWorker) {
          if (this.compareObject(originalWorker, worker)) {
              worker.processType = "UPDATE";
          }
      } else {
          worker.processType = "ADD";
      }
  });

  params.machines.forEach((machine: any) => {
      const originalMachine = this.originalMachines.find(m => m.machine.id === machine.machine_id);
      if (originalMachine) {
          if (this.compareObject(originalMachine, machine)) {
              machine.processType = "UPDATE";
          }
      } else {
          machine.processType = "ADD";
      }
  });

  return params;
}

    get isReferenceOnly(): boolean {
        return this.$store.getters.loginUser?.pdWhsRecRefOnly === true;
    }
}
